__turbopack_context__.v({
  "basic-card": "BasicCard-module-scss-module__PsmWiW__basic-card",
});
